/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import React from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
import { keysOf } from '../../common';
var paddingSizeToClassNameMap = {
  none: null,
  s: 'euiPageSideBar--paddingSmall',
  m: 'euiPageSideBar--paddingMedium',
  l: 'euiPageSideBar--paddingLarge'
};
export var PADDING_SIZES = keysOf(paddingSizeToClassNameMap);

/**
 * @deprecated Use the new EuiPageSidebarProps in page/page_sidebar instead
 */

/**
 * @deprecated Use the new EuiPageSidebar in page/page_sidebar instead
 */
export var EuiPageSideBar_Deprecated = ({
  children,
  className,
  sticky,
  paddingSize = 'none',
  ...rest
}) => {
  const classes = classNames('euiPageSideBar', paddingSizeToClassNameMap[paddingSize], {
    'euiPageSideBar--sticky': sticky
  }, className);
  return <div className={classes} {...rest}>
      {children}
    </div>;
};
EuiPageSideBar_Deprecated.propTypes = {
  /**
     * Adds `position: sticky`
     */
  sticky: PropTypes.bool,
  /**
     * Adds padding around the children
     */
  paddingSize: PropTypes.any,
  className: PropTypes.string,
  "aria-label": PropTypes.string,
  "data-test-subj": PropTypes.string,
  css: PropTypes.any
};
try {
  EuiPageSideBar_Deprecated.__docgenInfo = {
    tags: {
      deprecated: 'Use the new EuiPageSidebar in page/page_sidebar instead'
    },
    filePath: '/Users/briannahall/Documents/EUI/eui/src/components/page/page_side_bar/page_side_bar.tsx',
    description: '',
    displayName: 'EuiPageSideBar_Deprecated',
    methods: [],
    props: {
      sticky: {
        defaultValue: null,
        description: 'Adds `position: sticky`',
        name: 'sticky',
        parent: {
          fileName: 'eui/src/components/page/page_side_bar/page_side_bar.tsx',
          name: 'EuiPageSideBarProps_Deprecated'
        },
        declarations: [{
          fileName: 'eui/src/components/page/page_side_bar/page_side_bar.tsx',
          name: 'EuiPageSideBarProps_Deprecated'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      paddingSize: {
        defaultValue: {
          value: 'none'
        },
        description: 'Adds padding around the children',
        name: 'paddingSize',
        parent: {
          fileName: 'eui/src/components/page/page_side_bar/page_side_bar.tsx',
          name: 'EuiPageSideBarProps_Deprecated'
        },
        declarations: [{
          fileName: 'eui/src/components/page/page_side_bar/page_side_bar.tsx',
          name: 'EuiPageSideBarProps_Deprecated'
        }],
        required: false,
        type: {
          name: 'enum',
          raw: '"s" | "none" | "m" | "l"',
          value: [{
            value: '"s"'
          }, {
            value: '"none"'
          }, {
            value: '"m"'
          }, {
            value: '"l"'
          }]
        }
      },
      className: {
        defaultValue: null,
        description: '',
        name: 'className',
        parent: {
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-label': {
        defaultValue: null,
        description: '',
        name: 'aria-label',
        parent: {
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      'data-test-subj': {
        defaultValue: null,
        description: '',
        name: 'data-test-subj',
        parent: {
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      css: {
        defaultValue: null,
        description: '',
        name: 'css',
        parent: {
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        },
        declarations: [{
          fileName: 'eui/src/components/common.ts',
          name: 'CommonProps'
        }],
        required: false,
        type: {
          name: 'Interpolation<Theme>'
        }
      }
    },
    extendedInterfaces: ['EuiPageSideBarProps_Deprecated', 'CommonProps', 'HTMLAttributes', 'AriaAttributes', 'DOMAttributes']
  };
} catch (e) {}